// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__uT51r","body":"HomePage_body__U88hf","body_item":"HomePage_body_item__EpJno"};